<template>
  <div>
    <div class=" row mb-2" >
      <label class="col-sm-4 lh40 text-lr"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <el-time-picker value-format="HH:mm:ss"
            v-model="value" @change="$get_function(Data,value)"
            placeholder="任意时间点">
        </el-time-picker>
    </div>
  </div>
  </div>

</template>

<script>
    export default {
        data() {
            return {
              value: this.Data.data.c_value,

              // pickerOptions: {
              //       disabledDate(time) {
              //           return time.getTime() > Date.now();
              //       },
              //   },
                // value: [this.moment().subtract(1,'M').format('YYYY-MM-DD 00:00:00'), this.moment().format('YYYY-MM-DD 23:59:59')],
            }
        },

        created() {

        },
        name: "time_box",
        methods: {

        },
    }
</script>

<style scoped>

</style>
